import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '@/lib/utils';

const logoVariants = cva(
  'inline-flex items-center justify-center bg-[#5A5F5F] text-ewe-yellow font-bold  rounded-lg',
  {
    variants: {
      size: {
        sm: 'w-8 h-8 text-sm',
        default: 'w-10 h-10 text-lg',
        lg: 'w-12 h-12 text-xl',
        xl: 'w-16 h-16 text-2xl',
      },
    },
    defaultVariants: {
      size: 'default',
    },
  },
);

interface LogoProps
  extends
    React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof logoVariants> {}

function Logo({ className, size, ...props }: LogoProps) {
  return (
    <div className={cn('flex items-center', className)} {...props}>
      <div className={cn(logoVariants({ size }))}>EWE</div>
    </div>
  );
}

export { Logo, logoVariants };
